const defaultRenters = [
    {
        id: 468225196328,
        handle: "hertz",
        title: "Hertz",
        updated_at: "2025-05-09T07:15:10-04:00",
        body_html: "Hertz",
        published_at: "2023-11-15T16:37:44-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225196328",
        image: {
            created_at: "2023-11-15T16:37:43-05:00",
            alt: null,
            width: 68,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-Hertz.svg?v=1700084263"
        },
        price: 0,
        value: "ZE",
        loadingData: true,
    },
    {
        id: 468225163560,
        handle: "dollar",
        title: "Dollar",
        updated_at: "2025-05-08T17:06:55-04:00",
        body_html: "Dollar",
        published_at: "2023-11-15T16:37:11-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225163560",
        image: {
            created_at: "2023-11-15T16:37:10-05:00",
            alt: null,
            width: 82,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-Dollar.svg?v=1700084231"
        },
        price: 0,
        value: "ZR",
        loadingData: true,
    },
    {
        id: 468225229096,
        handle: "thrifty",
        title: "Thrifty",
        updated_at: "2025-05-09T02:35:10-04:00",
        body_html: "Thrifty",
        published_at: "2023-11-15T16:38:07-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225229096",
        image: {
            created_at: "2023-11-15T16:38:07-05:00",
            alt: null,
            width: 69,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-Thrifty.svg?v=1700084287"
        },
        price: 0,
        value: "ZT",
        loadingData: true,
    },
    {
        id: 468225392936,
        handle: "avis",
        title: "Avis",
        updated_at: "2025-05-09T09:50:24-04:00",
        body_html: "Avis",
        published_at: "2023-11-15T16:39:31-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225392936",
        image: {
            created_at: "2023-11-15T16:39:30-05:00",
            alt: null,
            width: 65,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-AVIS.svg?v=1700084370"
        },
        price: 0,
        value: "ZI",
        loadingData: true,
    },
    {
        id: 468225524008,
        handle: "budget",
        title: "Budget",
        updated_at: "2025-05-09T10:23:59-04:00",
        body_html: "Budget",
        published_at: "2023-11-15T16:40:24-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225524008",
        image: {
            created_at: "2023-11-15T16:40:23-05:00",
            alt: null,
            width: 113,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-Busdet.svg?v=1700084423"
        },
        price: 0,
        value: "ZD",
        loadingData: true,
    },
    {
        id: 468225458472,
        handle: "payless",
        title: "Payless",
        updated_at: "2025-05-01T05:16:47-04:00",
        body_html: "Payless",
        published_at: "2023-11-15T16:39:53-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225458472",
        image: {
            created_at: "2023-11-27T15:44:14-05:00",
            alt: null,
            width: 1200,
            height: 412,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/1200px-Payless_Car_Rental_logo_svg.png?v=1701117854"
        },
        price: 0,
        value: "ZA",
        loadingData: true,
    },
    {
        id: 468225294632,
        handle: "alamo",
        title: "Alamo",
        updated_at: "2025-05-09T07:40:13-04:00",
        body_html: "Alamo",
        published_at: "2023-11-15T16:39:05-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225294632",
        image: {
            created_at: "2023-11-15T16:39:05-05:00",
            alt: null,
            width: 61,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-Alamo.svg?v=1700084345"
        },
        price: 0,
        value: "AL",
        loadingData: true,
    },
    {
        id: 468225556776,
        handle: "national",
        title: "National",
        updated_at: "2025-05-08T20:26:14-04:00",
        body_html: "National",
        published_at: "2023-11-15T16:40:49-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225556776",
        image: {
            created_at: "2023-11-15T16:40:48-05:00",
            alt: null,
            width: 116,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-National.svg?v=1700084448"
        },
        price: 0,
        value: "ZL",
        loadingData: true,
    },
    {
        id: 468225261864,
        handle: "enterprise",
        title: "Enterprise",
        updated_at: "2025-05-08T05:40:07-04:00",
        body_html: "Enterprise",
        published_at: "2023-11-15T16:38:36-05:00",
        sort_order: "best-selling",
        template_suffix: "",
        published_scope: "global",
        admin_graphql_api_id: "gid://shopify/Collection/468225261864",
        image: {
            created_at: "2023-11-15T16:38:36-05:00",
            alt: null,
            width: 130,
            height: 28,
            src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/collections/Logo-Enterprise.svg?v=1700084316"
        },
        price: 0,
        value: "ET",
        loadingData: true,
    }
];
export default defaultRenters;
